import styled from "styled-components";

export const Styles = styled.div`
  .field-section {
    width: 200px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    label {
      font-size: 1rem;
      span {
        margin-left: 4px;
        color: #e74c3c;
        font-size: 20px;
      }
    }
    .is-error {
      border-color: #e74c3c;
    }
  }
`;
